export default function PrimaryButton({children, variant='primary', className, ...props}) {

    return (
        <button
            className={`${
                variant === 'primary' ? "bg-[#0C98FE] hover:bg-[#0A86D9] text-white":
                    "bg-[#D9F4FF] hover:bg-[#B3E0FF] text-[#11355A]"
            } px-[14px] py-[8px] lg:min-w-[200px] text-md   box-border rounded-lg  transition duration-300 ${className}`}
            {...props}
        >
            {children}
        </button>
    );
}